/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_X15_OpenInputs */

const en_invite_x15_open = /** @type {(inputs: Invite_X15_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the app`)
};

/** @type {(inputs: Invite_X15_OpenInputs) => LocalizedString} */
const ar_invite_x15_open = en_invite_x15_open;

/** @type {(inputs: Invite_X15_OpenInputs) => LocalizedString} */
const he_invite_x15_open = en_invite_x15_open;

/** @type {(inputs: Invite_X15_OpenInputs) => LocalizedString} */
const ur_invite_x15_open = en_invite_x15_open;

/** @type {(inputs: Invite_X15_OpenInputs) => LocalizedString} */
const es_invite_x15_open = en_invite_x15_open;

/** @type {(inputs: Invite_X15_OpenInputs) => LocalizedString} */
const fr_invite_x15_open = en_invite_x15_open;

/** @type {(inputs: Invite_X15_OpenInputs) => LocalizedString} */
const de_invite_x15_open = en_invite_x15_open;

/** @type {(inputs: Invite_X15_OpenInputs) => LocalizedString} */
const pt_invite_x15_open = en_invite_x15_open;

/** @type {(inputs: Invite_X15_OpenInputs) => LocalizedString} */
const hi_invite_x15_open = en_invite_x15_open;

/** @type {(inputs: Invite_X15_OpenInputs) => LocalizedString} */
const bn_invite_x15_open = en_invite_x15_open;

/**
* | output |
* | --- |
* | "Open the app" |
*
* @param {Invite_X15_OpenInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_x15_open = /** @type {((inputs?: Invite_X15_OpenInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_OpenInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_x15_open(inputs)
	if (locale === "he") return he_invite_x15_open(inputs)
	if (locale === "ur") return ur_invite_x15_open(inputs)
	if (locale === "es") return es_invite_x15_open(inputs)
	if (locale === "fr") return fr_invite_x15_open(inputs)
	if (locale === "de") return de_invite_x15_open(inputs)
	if (locale === "pt") return pt_invite_x15_open(inputs)
	if (locale === "hi") return hi_invite_x15_open(inputs)
	if (locale === "bn") return bn_invite_x15_open(inputs)
	return /** @type {LocalizedString} */ ("Open the app")
});